import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { navigateTo } from '../../redux/actions';
import { connect } from 'react-redux';

export const loadingStyle = {
  width: 50,
  margin: '10rem auto',
  height: 600,
};

class Sorry extends Component {
  componentDidMount() {
    setTimeout(() => navigateTo("/"), 5000)
  }
  render() {
    return (

      <div style={{textAlign: 'center', marginTop:60}}>
        <div>

        The action has been canceled due to an error. Please try again
        </div>

        <div>You will transfer to the login page</div>
        <div style={loadingStyle}>
          <CircularProgress color="primary" />
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return (
    {

    }
  )
}

const mapDispatchToProps = {
  navigateTo
}

export default connect(mapStateToProps, mapDispatchToProps)(Sorry)
